import React from "react";
import {
  Box,
  FormControlLabel,
  FormGroup,
  Switch,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useAppDispatch, useAppSelector } from "src/redux/store";
import { updateUserMFA } from "src/redux/features/user-slice";
import { getOrgInfo } from "src/redux/features/organization/organization-slice";

const MFASetting = () => {
  const dispatch = useAppDispatch();

  const org = useAppSelector((state) => state.organizationSlice.orgData);
  const isMfaEnabled = org?.securitySetting;
  const isParentMfaEnabled = org?.parentSecuritySetting;
  const isEmployeeMfaEnabled = org?.employeeSecuritySetting;

  const handleUpdateMfa = async (isMfaEnabled: boolean, role: number) => {
    await dispatch(
      updateUserMFA({
        tenantName: org.orgName,
        isMfaEnabled: !isMfaEnabled,
        role: role,
      })
    );
    dispatch(getOrgInfo({ useLoader: true }));
  };
  return (
    <Grid container spacing={3}>
      <Grid size={{ xs: 12, lg: 6 }}>
        <Box className="detailsCard">
          <Box className="detailsCard__header">
            <Typography className="detailsCard__title">MFA Setup</Typography>
          </Box>
          <Box className="detailsCard__body">
            <Box className="settingBox">
              <div className="settingBox__part">
                <FormGroup className="settingBox__field">
                  <h6 className="settingBox__field-title">
                    Enforce MFA for Admin Application
                  </h6>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={isMfaEnabled}
                        onChange={() => handleUpdateMfa(isMfaEnabled, 0)}
                      />
                    }
                    label={isMfaEnabled ? "On" : "Off"}
                  />
                </FormGroup>
              </div>
            </Box>
            <Box className="settingBox">
              <div className="settingBox__part">
                <FormGroup className="settingBox__field">
                  <h6 className="settingBox__field-title">
                    Enforce MFA for Parent Application
                  </h6>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={isParentMfaEnabled}
                        onChange={() => handleUpdateMfa(isParentMfaEnabled, 1)}
                      />
                    }
                    label={isParentMfaEnabled ? "On" : "Off"}
                  />
                </FormGroup>
              </div>
            </Box>
            <Box className="settingBox">
              <div className="settingBox__part">
                <FormGroup className="settingBox__field">
                  <h6 className="settingBox__field-title">
                    Enforce MFA for Employee Application
                  </h6>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={isEmployeeMfaEnabled}
                        onChange={() =>
                          handleUpdateMfa(isEmployeeMfaEnabled, 2)
                        }
                      />
                    }
                    label={isEmployeeMfaEnabled ? "On" : "Off"}
                  />
                </FormGroup>
              </div>
            </Box>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default MFASetting;
